<template>
	<modal
		:active="active"
		:dismissable="false"
		title="Are you still there?"
		@dismiss="dismiss"
	>

		<modal-body>
			<p>
                Your current session is about to expire.
                For your security, portal sessions automatically end after a period of inactivity.
                This greatly reduces the chances that someone else will access
                your information if you forget to sign out.
            </p>

            <p>
                Your current session will expire in {{secondsRemaining}} seconds.
            </p>
		</modal-body>

		<modal-actions>
			<btn primary @click="renew">I'm still here!</btn>
			<btn link @click="logout">Sign out</btn>
		</modal-actions>
		
	</modal>
</template>


<script>
    import { ModalMixin } from 'pdk/mixins';


	export default {
		name: 'idle-timeout-modal',
        mixins: [ModalMixin],
        props: {
            interval: {
                type: Number,
                default: 1000 // In milliseconds
            },
            threshhold: {
                type: Number,
                default: 60 // In seconds
            }
        },
        data() {
            return {
                secondsRemaining: undefined,
                countdownHandler: undefined
            };
        },
        created() {
            this.start();
        },
        beforeDestroy() {
            this.end();
        },
        methods: {
            start() {
                this.end();
                let idleTimeoutOpen = false; 

                this.countdownHandler = setInterval(() => {
                    this.secondsRemaining = this.getSecondsRemaining();

                    if(this.$store.state.dashboard.tv.active)
                    {
                        this.end();
                    }
                    if (this.secondsRemaining <= this.threshhold && !this.active) { 
                        this.open();
                        idleTimeoutOpen = true; 
                    }
                    else if (this.secondsRemaining <= 0){
                        this.logout(); 
                    }
                    else if (this.active && this.secondsRemaining > this.threshhold && idleTimeoutOpen){
                        this.close();
                        idleTimeoutOpen = false;
                    }
                }, this.interval);

                this.$emit('start');
            },
            end() {
                if (this.countdownHandler) {
                    clearInterval(this.countdownHandler);
                    this.countdownHandler = undefined;
                    this.$emit('end');
                }
            },
            getSecondsRemaining(){
                const expiration = this.$auth.tokenParsed.exp;
                if (!expiration) return 0;

                const secondsRemaining = expiration - Math.floor(new Date().getTime() / 1000);

                if (secondsRemaining <= 0) return 0;
                return secondsRemaining;
            },
			renew() {
				this.$emit('renew');
            },
            logout() {
                this.$emit('logout');
                this.close();
            }
		}
	};
</script>
